exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".group-header{background-color:#ddd!important;font-weight:700}.group-footer,.group-header td.td-header{background-color:#f4f4f4!important;font-weight:700}.group-footer-sub td.td-footer{background-color:#f1efef!important;font-weight:700;padding-left:0!important;font-size:15px!important}.group-footer td.td-footer{background-color:#ddd!important;font-weight:700;padding-left:0!important}.jas-bg-red{background-color:#fbefef!important}.jas-bg-red-strong{background-color:#f9dfdf!important}.jas-bg-green{background-color:#e2efda!important}.jas-bg-gray{background-color:#d9d9d9!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Report/JobAgentAuditStock.vue
// module id = 1115
// module chunks = 0